import {formatDate} from '@cindedi/utilities/formatDate';

export function formatEventDate(date: Date | string): string {
  return formatDate(date, 'datetime');
}
